import React from 'react';
import { bool, shape, string } from 'prop-types';

const StatusPlanned = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6.99413 1.16663C3.77413 1.16663 1.16663 3.77996 1.16663 6.99996C1.16663 10.22 3.77413 12.8333 6.99413 12.8333C10.22 12.8333 12.8333 10.22 12.8333 6.99996C12.8333 3.77996 10.22 1.16663 6.99413 1.16663ZM6.99996 11.6666C4.42163 11.6666 2.33329 9.57829 2.33329 6.99996C2.33329 4.42163 4.42163 2.33329 6.99996 2.33329C9.57829 2.33329 11.6666 4.42163 11.6666 6.99996C11.6666 9.57829 9.57829 11.6666 6.99996 11.6666ZM6.41663 4.08329H7.29163V7.14579L9.91663 8.70329L9.47913 9.42079L6.41663 7.58329V4.08329Z" fill="currentColor" />
  </svg>
);

StatusPlanned.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default StatusPlanned;
